export type AccountSummary = {
  value: number;
  time: number;
};

export const Timescale = {
  day: '24h',
  week: '7D',
  month: '30D',
  all: 'all',
} as const;

export type TimescaleValue = (typeof Timescale)[keyof typeof Timescale];
